// extracted by mini-css-extract-plugin
export default {"container":"mainLayout_container__dNfvF"};